export default () => {
    const productsPage = document.querySelector(".in-e-shop.type-category");

    if (productsPage) {
        // Reorder Coffe Beans
        $('div.param-filter-top div:has(input[data-filter-id="72"])').insertAfter('div.param-filter-top div:has(input[data-filter-id="2"])')
        //Reorder 1kg
        $('div.param-filter-top div:has(input[data-filter-id="37"])').insertAfter('div.param-filter-top div:has(input[data-filter-id="16"])')
        //Reorder 250g
        $('div.param-filter-top div:has(input[data-filter-id="34"])').insertAfter('div.param-filter-top div:has(input[data-filter-id="16"])')
        //Reorder Christmas Box
        $('div.param-filter-top div:has(input[data-filter-id="46"])').insertAfter('div.param-filter-top div:has(input[data-filter-id="2"])')

        const products = document.querySelector(".products.products-page .product");
        products.forEach((product) => {
            const merchFlag = product.querySelector(".flag.flag-merch");

            if (merchFlag) {
                const property = product.querySelectorAll(".property")

                if (property) {
                    property.forEach((property) => {
                        property.classList.add("hide-before")
                    })
                }
            }
        })
    }
};